import type { Campaign } from '@/shared/types/entities';
import { CampaignStatusBadge } from '@/shared/components/promote/CampaignStatusBadge';
import styles from './CampaignCard.module.scss';

export interface CampaignCardProps {
  campaign: Campaign;
  onClick?: (campaign: Campaign) => void;
}

export function CampaignCard({ campaign, onClick }: CampaignCardProps) {
  return (
    <div
      className={styles.card}
      onClick={() => onClick?.(campaign)}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick(campaign);
        }
      }}
    >
      <div className={styles.header}>
        <h3 className={styles.name}>{campaign.name}</h3>
        <CampaignStatusBadge status={campaign.status} />
      </div>
      <div className={styles.meta}>
        <span className={styles.platform}>{campaign.platform}</span>
        {campaign.eventName && <span className={styles.event}>{campaign.eventName}</span>}
      </div>
    </div>
  );
}
